import { appStyles } from "../../config/config.styles/App"
import { Styles } from "../../config"

export default {
	container: {
		...appStyles.appPadding,
		boxSizing: "border-box",
		width: "100%",
		maxWidth: "1600px",
		height: "75px",
		alignItems: "center",
		background: "#fcfdff",

		"*": {
			boxSizing: "border-box"
		}
	},

	footer: {
		color: Styles.Color.primary
	}
}
